import { Turnstile as TurnstileWidget } from '@marsidev/react-turnstile'
import { useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

export const Turnstile = ({ onSuccess, onError, onExpire }) => {
  const isEnabled = import.meta.env.VITE_TURNSTILE_ENABLED === 'true'
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY
  const turnstileRef = useRef(null)

  const handleSuccess = useCallback(
    (token) => {
      // Clean up any old localStorage entries (removing deprecated caching)
      localStorage.removeItem('turnstile_verified')
      onSuccess(token)
    },
    [onSuccess]
  )

  const handleError = useCallback(
    (error) => {
      // Reset the widget on error to allow retry
      if (turnstileRef.current?.reset) {
        turnstileRef.current.reset()
      }

      // Check for iframe load error
      if (error?.code === 200500 || error?.internalRepr === 'iframe_load_err') {
        onError?.({
          ...error,
          userMessage:
            'Security verification blocked. Please disable ad blockers or try a different browser.',
        })
      } else {
        onError?.(error)
      }
    },
    [onError]
  )

  const handleExpire = useCallback(() => {
    onExpire?.()
  }, [onExpire])

  if (!isEnabled) {
    return null
  }

  if (!siteKey) {
    return null
  }

  return (
    <div className="flex justify-center my-4">
      <TurnstileWidget
        ref={turnstileRef}
        siteKey={siteKey}
        onSuccess={handleSuccess}
        onError={handleError}
        onExpire={handleExpire}
        options={{
          theme: 'dark',
          size: 'normal',
          appearance: 'interaction-only',
          action: 'chat-message',
          execution: 'render',
        }}
      />
    </div>
  )
}

Turnstile.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onExpire: PropTypes.func,
}
